import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { Phrase } from 'components/shared';
import { UitkHeading, UitkText } from 'uitk-react-text';

import { BaggageFeesInformationType, BaggageFeesInformationDetailType } from 'types/search/listings';
import { BaggageFeesInformationDetailCard } from 'components/search/listings/offer/details/baggage-fees-information-detail-card';

export const BaggageFeesInformation = (baggageFeesInformation: BaggageFeesInformationType) => {
  const { label, bagFeesMoreInfo } = baggageFeesInformation;

  return (
    <div className="all-x-padding-three" data-test-id="baggage-info">
      <Experiment name="PWA_Sidesheet_redesign">
        <ExperimentControl>
          <UitkHeading level={3} size={300}>
            {label}
          </UitkHeading>
        </ExperimentControl>
        <ExperimentVariant bucket={1} />
      </Experiment>
      <div className="all-t-margin-three" data-test-id="bag-fee-info">
        <Experiment name="PWA_Sidesheet_redesign">
          <ExperimentControl>
            <BaggageFeesInformationDetailCard {...baggageFeesInformation} />
          </ExperimentControl>
          <ExperimentVariant bucket={1} />
        </Experiment>
        {bagFeesMoreInfo.map((info, index) => (
          <UitkText key={index} size={200} spacing="three">
            <Phrase {...info} />
          </UitkText>
        ))}
      </div>
    </div>
  );
};

export const BaggageFeesInformationDetail = (baggageFeesInformationDetail: BaggageFeesInformationDetailType) => (
  <tr>
    <td>{baggageFeesInformationDetail.topic}</td>
    <td>{baggageFeesInformationDetail.detail}</td>
  </tr>
);
